export default __webpack_public_path__ + "static/media/arrow-close-menu-right.8f65da8b.svg";